'use strict'
Object.defineProperty(exports, '__esModule', { value: true })
exports.toLocaleCapitalizeFirstLetter = void 0
var toLocaleUpperCaseFirstLetter = function (word, locale) {
  return word.charAt(0).toLocaleUpperCase(locale) + word.slice(1)
}
var toLocaleCapitalizeFirstLetter = function (word, locale) {
  if (!word) return ''
  var localeDefined = locale || navigator.language
  return word
    .split(' ')
    .map(function (item) {
      return toLocaleUpperCaseFirstLetter(item, localeDefined)
    })
    .join(' ')
}
exports.toLocaleCapitalizeFirstLetter = toLocaleCapitalizeFirstLetter
//# sourceMappingURL=toLocaleCapitalizeFirstLetter.js.map
